/** /bn/about পেজের স্ট্যাটিক কনটেন্ট — শুধু ডেটা, কোনো JSX নেই। */

export const BN_PILLARS = [
  {
    t: "ব্যবসা অনুযায়ী কৌশল",
    d: "গভীর কীওয়ার্ড গবেষণা থেকে তৈরি আলাদা এসইও পরিকল্পনা — রংপুরের লোকাল ব্যবসা হোক বা আন্তর্জাতিক ব্র্যান্ড, সঠিক দর্শকের কাছে পৌঁছানোই লক্ষ্য।",
  },
  {
    t: "টেকনিক্যাল এসইও",
    d: "সাইট আর্কিটেকচার, Core Web Vitals, পেজ স্পিড, স্কিমা ও ভয়েস সার্চ প্রস্তুতি — যে ভিত্তির ওপর র‍্যাঙ্কিং দাঁড়ায়।",
  },
  {
    t: "নৈতিক পদ্ধতি",
    d: "১০০% হোয়াইট-হ্যাট এসইও। শর্টকাট নয়, টেকসই কাজ — যাতে পেনাল্টির ঝুঁকি না থাকে।",
  },
  {
    t: "মাপা যায় এমন ফলাফল",
    d: "স্বচ্ছ অ্যানালিটিক্স ও মাসিক রিপোর্ট — কী কাজ করছে আর ROI কোথা থেকে আসছে, সেটা সবসময় পরিষ্কার থাকে।",
  },
];

export const BN_WHY = [
  "রংপুরে দীর্ঘ অভিজ্ঞতা এবং প্রতিটি ক্যাম্পেইনে ক্লায়েন্ট-কেন্দ্রিক কাজের অভ্যাস।",
  "লোকাল ও আন্তর্জাতিক দর্শকের জন্য টেকনিক্যাল এসইও ও কনটেন্ট পরিকল্পনা।",
  "লোকাল এসইও কৌশল যা রংপুরের ব্যবসাকে ম্যাপ প্যাক ও 'near me' সার্চে সামনে আনে।",
  "টেকনিক্যাল এসইও, ই-কমার্স অপটিমাইজেশন ও পূর্ণাঙ্গ ডিজিটাল মার্কেটিং — সব এক জায়গায়।",
  "ভ্যানিটি মেট্রিক নয় — মান, ক্লায়েন্ট সন্তুষ্টি আর বাস্তব ROI-এর ওপর জোর।",
  "সার্চ ইঞ্জিনের নতুন আপডেটের আগেই প্রস্তুতি, যাতে ফল বছরের পর বছর টিকে থাকে।",
];

export const BN_SKILLS = [
  { t: "এসইও বিশ্লেষণ" },
  { t: "এসইও অডিট" },
  { t: "অপটিমাইজেশন" },
  { t: "লোকাল এসইও" },
];

export const BN_ABOUT_SERVICES = [
  { i: "০১", t: "রংপুরের ব্যবসার জন্য লোকাল এসইও", d: "এলাকাভিত্তিক কীওয়ার্ড, Google Business Profile অপটিমাইজেশন, লোকাল সাইটেশন ও এলাকার ল্যান্ডিং পেজ — ম্যাপ প্যাক জেতার জন্য।" },
  { i: "০২", t: "টেকনিক্যাল এসইও ও Core Web Vitals", d: "ক্রলযোগ্যতা, ইনডেক্সেশন, স্কিমা মার্কআপ, ইন্টারনাল লিংকিং ও সাইট স্পিড — বট ও মানুষ দুইয়ের জন্যই।" },
  { i: "০৩", t: "ই-কমার্স ও Shopify এসইও", d: "প্রোডাক্ট পেজ অপটিমাইজেশন, রিচ রেজাল্টের জন্য স্ট্রাকচার্ড ডেটা, ফেসেটেড নেভিগেশন ও কনভার্সন-সচেতন অন-পেজ কাজ।" },
  { i: "০৪", t: "কনটেন্ট ও কীওয়ার্ড কৌশল", d: "ইনটেন্ট-ভিত্তিক কীওয়ার্ড গবেষণা, টপিক্যাল অথরিটি পরিকল্পনা এবং র‍্যাঙ্ক ও কনভার্ট — দুটোর জন্য লেখা কনটেন্ট।" },
  { i: "০৫", t: "AI ও জেনারেটিভ এসইও (AEO)", d: "Answer Engine Optimization, এন্টিটি অপটিমাইজেশন ও সিমান্টিক এসইও — যাতে AI Overviews ও ChatGPT-তে আপনার ব্র্যান্ড আসে।" },
  { i: "০৬", t: "অনলাইন রেপুটেশন ম্যানেজমেন্ট", d: "ব্র্যান্ড মেনশন পর্যবেক্ষণ, রিভিউ ব্যবস্থাপনা এবং গুগলের প্রথম পাতায় আপনার গল্প আপনার নিয়ন্ত্রণে রাখা।" },
];

export const BN_ABOUT_FAQ = [
  {
    q: "বাংলাদেশের সেরা এসইও এক্সপার্ট কে?",
    a: "প্রাসঙ্গিক কাজ, তারিখসহ ডেটা, লিখিত স্কোপ ও রিপোর্টিং অ্যাক্সেস যাচাই করুন। নিজেকে সেরা বলা স্বাধীন প্রমাণ নয়।",
  },
  {
    q: "ফ্রিল্যান্সার তামালের আলাদা দিক কী?",
    a: "আপনি কাজ করবেন সরাসরি আমার সঙ্গে — কোনো অ্যাকাউন্ট ম্যানেজার নয়। প্রতিটি অডিট, GSC রিভিউ ও স্কিমা পরিবর্তন সেই মানুষটাই করেন যাকে আপনি নিয়োগ দিয়েছেন। লিখিত স্কোপ ও রিপোর্টিংয়ে দায়িত্ব পরিষ্কার থাকে।",
  },
  {
    q: "এসইওর ফল পেতে কত সময় লাগে?",
    a: "নির্দিষ্ট তারিখের সৎ প্রতিশ্রুতি দেওয়া যায় না। টেকনিক্যাল সংশোধন গুগল পেজ আবার ক্রল করলে Search Console-এ যাচাই করা যায়; লোকাল ও প্রতিযোগিতামূলক র‍্যাংকিং নির্ভর করে শুরুর অবস্থা, রিভিউ ও প্রতিযোগীদের উপর। প্রথম সপ্তাহে বেসলাইন রেকর্ড করি এবং প্রতি মাসে অগ্রগতি দেখি।",
  },
  {
    q: "এসইও কি লোকাল ও গ্লোবাল—দুইভাবেই ব্যবসা বাড়াতে পারে?",
    a: "হ্যাঁ। একই ডেস্ক থেকে রংপুরের ম্যাপ-প্যাক প্রজেক্ট আর যুক্তরাষ্ট্র/ইউরোপের SaaS ক্লায়েন্ট—দুটোই চালাই। ক্রল, ইনটেন্ট, স্কিমা, লিংক—মূল বিষয়গুলো বদলায় না; শুধু কীওয়ার্ডের পরিসর আর কনটেন্টের গভীরতা বদলায়।",
  },
  {
    q: "চলমান এসইও কেন জরুরি?",
    a: "ব্যবসার তথ্য, সার্চ রেজাল্ট ও ওয়েবসাইট বদলায়। নিয়মিত পর্যালোচনায় প্রকৃত সমস্যা চিহ্নিত করা যায়; দ্রুত রিকভারির গ্যারান্টি নয়।",
  },
  {
    q: "ফ্রিল্যান্সার আর এজেন্সির পার্থক্য কী?",
    a: "এজেন্সি আপনাকে স্ট্র্যাটেজিস্ট দেখিয়ে জুনিয়র দেয়। আমার ক্ষেত্রে যিনি প্রজেক্ট স্কোপ করেন, তিনিই ক্রল চালান, স্কিমা লেখেন, আর রাত ১১টায় মেসেজের উত্তর দেন।",
  },
];

/** "আমার পদ্ধতি" কার্ড। */
export const BN_APPROACH = [
  { t: "ডেটাভিত্তিক সিদ্ধান্ত", d: "প্রতিটি সুপারিশের পেছনে ট্রাফিক, ইনটেন্ট ও প্রতিযোগী ডেটা — অনুমান নয়।" },
  { t: "১০০% হোয়াইট-হ্যাট", d: "গুগলের গাইডলাইন মেনে টেকসই পদ্ধতি — দীর্ঘমেয়াদে আপনার র‍্যাঙ্কিং সুরক্ষিত থাকে।" },
  { t: "টেমপ্লেট নয়, আপনার সাইটের জন্য", d: "ঢাকার একটি Shopify স্টোর আর বার্লিনের B2B SaaS-এর কীওয়ার্ড ম্যাপ, স্কিমা ও লিংক পরিকল্পনা এক হতে পারে না।" },
];

export const BN_AI_SEARCH_POINTS = [
  { t: "অ্যানসার ইঞ্জিন অপটিমাইজেশন (AEO)", d: "প্রশ্নভিত্তিক হেডিং, ছোট সরাসরি উত্তর, FAQ ও ধাপে ধাপে কাঠামো — যাতে গুগলের ফিচার্ড স্নিপেট, AI Overviews ও ভয়েস অ্যাসিস্ট্যান্ট আপনার পেজ থেকে উত্তর তুলে নিতে পারে।", to: "/bn/services/aeo" },
  { t: "জেনারেটিভ ইঞ্জিন অপটিমাইজেশন (GEO)", d: "সব জায়গায় একই ব্যবসার তথ্য, স্কিমা মার্কআপ, llms.txt এবং সূত্রসহ উদ্ধৃতিযোগ্য কন্টেন্ট — যাতে ChatGPT, Perplexity ও Gemini আপনার ব্যবসাকে বুঝে উল্লেখ করতে পারে।", to: "/bn/services/geo" },
  { t: "সৎভাবে মাপা", d: "এআই-তে উল্লেখ পাওয়ার নিশ্চয়তা কেউ দিতে পারে না। কোন প্রশ্ন ও সার্চ যাচাই করা হলো, সাইটে কী বদলানো হলো এবং কবে — সব রেকর্ড রাখি, যাতে অগ্রগতি দাবি নয়, দেখা যায়।", to: "/bn/blog/aeo-ai-search-citation-bangla" },
] as const;
